var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navigation__link"},[_c('h3',[_c('router-link',{attrs:{"to":_vm.link,"active-class":"navigation__link--active"},nativeOn:{"click":function($event){return _vm.closeNavigation($event)}}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }